export const TAGS = [
    'act',
    'advertisement',
    'commercial',
    'dance',
    'feature',
    'health',
    'monologue',
    'news',
    'picture',
    'podcast',
    'poetry',
    'poster',
    'reels',
    'script',
    'short',
    'skit',
    'travel',

    // NEW ADDITIONS
    'behind-the-scenes',
    'beauty',
    'brand-story',
    'comedy',
    'cover-song',
    'documentary',
    'education',
    'fashion',
    'fitness',
    'gaming',
    'interview',
    'lifestyle',
    'makeup',
    'modeling',
    'music-video',
    'photography',
    'promo',
    'reaction',
    'tutorial',
    'ugc',
    'vfx',
    'vlog',
    'voiceover',
];

export const PROJECT_CATEGORY = [
    'act',
    'advertisement',
    'album art',
    'animation',
    'audition tape',
    'beauty',
    'behind-the-scenes (BTS)',
    'beat production',
    'brand story',
    'case study',
    'character study',
    'cinematic scene',
    'cold read',
    'color grading sample',
    'commercial',
    'comedy routine',
    'concept art',
    'cooking video',
    'dance',
    'design (graphic design)',
    'dialogue scene',
    'diy craft',
    'dj mix',
    'documentary',
    'education',
    'esports highlight',
    'explainer video',
    'feature',
    'fashion',
    'fashion sketches',
    'fitness routine',
    'gaming clip',
    'green screen performance',
    'hair styling demo',
    'health',
    'how-to guide',
    'improv',
    'instrumental performance',
    'interview',
    'lifestyle',
    'lookbook',
    'masterclass',
    'makeup tutorial',
    'model (3D model)',
    'monologue',
    'motion graphics',
    'motivational talk',
    'music video',
    'news',
    'novel excerpt',
    'pantommime',
    'pet content',
    'photography series',
    'picture',
    'pitch',
    'pitch deck',
    'poetry',
    'poetry slam performance',
    'poster',
    'product review',
    'promo video',
    'q&a',
    'rap',
    'reaction video',
    'reels',
    'runway walk',
    'screen test',
    'script',
    'short',
    'skit',
    'song cover',
    'sound design',
    'spoken word',
    'stop motion',
    'story outline',
    'storyboard',
    'storytime',
    'stunt / action reel',
    'tech build / setup',
    'testimonial',
    'travel',
    'tutorial',
    'ugc',
    'unboxing',
    'video essay',
    'vfx showcase',
    'vlog',
    'voice acting demo',
    'voice-over demo',
    'wellness tips',
];
export const EMAIL_TYPE = [
    { id: 0, title: 'contest submission notification email' },
    { id: 1, title: 'contest notification email' },
    { id: 3, title: 'voting reminder email' },
    { id: 4, title: 'send contest open email' },
];
